import { ReactNode } from "react";
import InfluencerNavigation from "./InfluencerNavigation";
import InfluencerFooter from "./InfluencerFooter";

interface InfluencerLayoutProps {
  children: ReactNode;
  currentPage?: "Dashboard" | "Brand Resources" | "Performance" | "Settings" | "Help";
}

export default function InfluencerLayout({ 
  children, 
  currentPage = "Dashboard" 
}: InfluencerLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-purple-50 to-white">
      <InfluencerNavigation currentPage={currentPage} />
      <main className="flex-1">
        {children}
      </main>
      <InfluencerFooter />
    </div>
  );
}